import React from 'react'
import Header from 'components/Header'
import ErrorBoundary from 'components/ErrorBoundary'

const index = ({ children }) => {
    return (
        <div className="wrapper">
            <Header />
            <div className="detail-view-wrapper">
                <ErrorBoundary>{children}</ErrorBoundary>
            </div>
        </div>
    )
}

export default index
